export const base64UrlEncode = (input: string) => {
  const utf8 = encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, (_, p) =>
    String.fromCharCode(parseInt(p, 16)),
  )
  const b64 = btoa(utf8)
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export const base64UrlDecode = (input: string) => {
  // restore base64 padding
  try {
    let b64 = input.replace(/-/g, '+').replace(/_/g, '/')
    const pad = b64.length % 4
    if (pad) b64 += '='.repeat(4 - pad)
    const bin = atob(b64)
    // convert binary -> percent-encoding -> decodeURIComponent (UTF-8 safe)
    const pct = bin
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
    return decodeURIComponent(pct)
  } catch {
    return ''
  }
}
